export const TicketContentStyles = {
    px: 3,
    pb: 2
}

export const TicketFieldsStyles = {
    pt: 1
}

export const TicketActionsStyles = {
    px: 3,
    pb: 2
}

    export const DialogStyles = {
        //set color to white if dark mode is on or else set to black
        color: (theme) => 
            theme.palette.mode === "dark"
                ? "white "
                : "black ",
        fontFamily: ["SlimIMS, Century "].join(",")
    }
